import { useEffect } from 'react';

/**
 * Hook to add/remove a class from the document body based on a condition.
 * The class is automatically removed when the component unmounts.
 *
 * @param className - The class name to add/remove from the body
 * @param condition - When true, the class is added; when false, it's removed
 */
export function useBodyClass(className: string, condition: boolean): void {
  useEffect(() => {
    if (condition) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }

    return () => {
      document.body.classList.remove(className);
    };
  }, [className, condition]);
}
